export function createResizeHandles(system, panel) {
  const directions = ['left', 'right', 'top', 'bottom'];
  directions.forEach(dir => {
    const handle = document.createElement('div');
    handle.className = `resize-handle resize-${dir}`;
    handle.dataset.direction = dir;
    handle.addEventListener('pointerdown', system.onResizePointerDown.bind(system));
    panel.appendChild(handle);
  });
}

export function onResizePointerDown(system, e) {
  e.stopPropagation();
  e.preventDefault();

  const handle = e.currentTarget;
  const panel = handle.closest('.panel');
  if (!panel) return;

  if (system.isMobileLayout()) return;
  if (panel.classList.contains('focused')) return;
  if (panel.classList.contains('minimized')) return;

  system.bringToFront(panel);

  const style = window.getComputedStyle(panel);
  const matrix = new DOMMatrixReadOnly(style.transform);
  const startTranslateX = matrix.m41;
  const startTranslateY = matrix.m42;

  system.resizing = {
    panel,
    direction: handle.dataset.direction,
    pointerId: e.pointerId,
    startX: e.clientX,
    startY: e.clientY,
    startWidth: panel.offsetWidth,
    startHeight: panel.offsetHeight,
    startTranslateX,
    startTranslateY,
  };

  panel.classList.add('resizing-active');
  panel.style.willChange = 'width, height, transform';

  const existingOverlay = document.getElementById('resize-iframe-overlay');
  if (!existingOverlay) {
    const overlay = document.createElement('div');
    overlay.id = 'resize-iframe-overlay';
    overlay.style.position = 'fixed';
    overlay.style.top = '0';
    overlay.style.left = '0';
    overlay.style.width = '100vw';
    overlay.style.height = '100vh';
    overlay.style.zIndex = '9999';
    overlay.style.cursor = window.getComputedStyle(handle).cursor;
    overlay.style.background = 'transparent';
    document.body.appendChild(overlay);
  }
}

export function handleResize(system, e) {
  const { panel, direction, startX, startY, startWidth, startHeight, startTranslateX, startTranslateY } = system.resizing;

  const dx = e.clientX - startX;
  const dy = e.clientY - startY;

  let newWidth = startWidth;
  let newHeight = startHeight;
  let translateX = startTranslateX;
  let translateY = startTranslateY;

  const minWidth = 180;
  const minHeight = 120;

  if (direction === 'right') {
    newWidth = Math.max(minWidth, startWidth + dx);
  } else if (direction === 'left') {
    const potentialWidth = startWidth - dx;
    if (potentialWidth >= minWidth) {
      newWidth = potentialWidth;
      translateX = startTranslateX + dx;
    }
  } else if (direction === 'bottom') {
    newHeight = Math.max(minHeight, startHeight + dy);
  } else if (direction === 'top') {
    const potentialHeight = startHeight - dy;
    if (potentialHeight >= minHeight) {
      newHeight = potentialHeight;
      translateY = startTranslateY + dy;
    }
  }

  panel.style.width = `${newWidth}px`;
  panel.style.height = `${newHeight}px`;
  panel.style.transform = `translate(${translateX}px, ${translateY}px) translateZ(0)`;
}
